<template>
  <div>
    <el-input class="search-el" size="mini" v-model="query.name" placeholder="请输入老师名称"></el-input>
    <el-input class="search-el" size="mini" v-model="query.order_no" placeholder="请输入订单编号"></el-input>
    <el-select
        class="search-el"
        size="mini"
        v-model="query.review_status"
        placeholder="审核状态"
        clearable
        filterable
    >
      <el-option label="审核状态" value=""></el-option>
      <el-option label="部门待审核" value="1"></el-option>
      <el-option label="COO待审核" value="2"></el-option>
      <el-option label="已驳回" value="9"></el-option>
      <el-option label="审核通过" value="10"></el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getListQuery()">
      查询
    </el-button>

    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
      >
        <el-table-column prop="id" label="ID" align="center" min-width="5%"></el-table-column>
        <el-table-column prop="order_no" label="订单编号" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="name" label="老师名称" align="center" min-width="12%"></el-table-column>
        <el-table-column prop="type" label="类型" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="total_amount" label="订单价格" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="created_at" label="支付时间" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="settlement_base" label="本次结算基数(按次结算)" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="counsel_time" label="本次咨询起止时间" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="settlement_ratio" label="结算比例" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="settlement_amount" label="结算金额" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="review_status" label="审核状态" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" align="center"
                       @click="approveList.chooseOrgVisible = true;getApproveList(row.id);">{{ row.review_status }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="咨询日志" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small"
                       @click="row.service_log_id == 0 ? counselLogList(row.id) : counselLogInfo(row.service_log_id)">查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <div v-if="(row.review_status_value == 1 && row.psy_department_status == 1) || (row.review_status_value == 2 && row.psy_coo_status == 1)" style="margin-top: 5px">
              <el-button type="primary" size="mini" @click="approve.chooseOrgVisible = true;isApprove(row.id, row.review_status_value)">审核</el-button>
            </div>
            <div v-else>
              <span>无</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
        title="咨询日志"
        :visible.sync="counselLog.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="counselLogUseFormOnClose"
        width="80%"
    >
      <!--列表-->
      <el-table
          border
          :data="counselLog.result.data"
          highlight-current-row
          v-loading="counselLog.listLoading1"
          style=""
      >
        <el-table-column prop="counsel_time" label="咨询时间" align="center" min-width="65%"></el-table-column>
        <el-table-column label="操作" align="center" min-width="35%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small"
                       @click="counselLogInfo(row.id)">查看咨询日志
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="counselLogList"
          :current-page.sync="counselLog.query.page"
          :page-size="counselLog.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="counselLog.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog title="咨询日志详情" :visible.sync="settlement.chooseOrgVisible" width="35%">
      <div v-if="settlement.result.data != null">
        <ul v-for="(item, index) in settlement.result.data" :key="index">
          <div>{{ index + 1 }}、{{ item.title }}</div>
          <li v-for="(i, d) in item.child" :key="d">{{ i.title }}:{{ i.value }}</li>
        </ul>
      </div>
      <div v-else>
        <span>咨询日志未填写</span>
      </div>
    </el-dialog>

    <el-dialog
        title="审核详情"
        :visible.sync="approveList.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="approveListFormOnClose"
        width="70%"
    >
      <!--列表-->
      <el-table
          border
          :data="approveList.result.data"
          highlight-current-row
          v-loading="approveList.listLoading1"
          style=""
      >
        <el-table-column prop="admin_id" label="审核人" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="status" label="审核结果" align="center" min-width="15%"></el-table-column>
        <el-table-column prop="review_desc" label="审核理由" align="center" min-width="30%"></el-table-column>
        <el-table-column prop="created_at" label="审核时间" align="center" min-width="15%"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="审核" :visible.sync="approve.chooseOrgVisible" width="35%">
      <el-form :model="approve.query">
        <el-form-item label="状态">
          <el-radio-group v-model="approve.query.action">
            <el-radio :label="1">同意</el-radio>
            <el-radio :label="0">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核理由">
          <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="approve.query.reason">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approve.chooseOrgVisible = false">取 消</el-button>
        <el-button type="primary" @click="approve.chooseOrgVisible = false; addApprove()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  showCounselLogList,
  showCounselLogInfo,
  getVerifyList,
  verify,
  getVerifyRecord
} from "@/api/psySettlements";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        name: "",
        order_no: "",
        review_status: ''
      },
      counselLog: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          psy_settlement_id: 0,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      settlement: {
        chooseOrgVisible: false,
        query: {
          service_log_id: 0,
        },
        result: {
          data: [],
        },
      },

      approveList: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          id: 0,
        },
        result: {
          data: [],
        },
      },
      approve: {
        chooseOrgVisible: false,
        formLabelWidth: '120px',
        query: {
          action: 1, //状态，agree-同意，refuse-拒绝
          reason: '',
          review_status_value: 0,
          id: 0
        },
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getListQuery(){
      this.query.page = 1
      this.getList()
    },

    getList() {
      this.loading = true;
      getVerifyList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    // 弹窗关闭
    counselLogUseFormOnClose() {
      this.counselLog.query.page = 1;
      this.counselLog.result = {
        total: 0,
        data: [],
      };
      this.counselLog.chooseOrgVisible = false;
      this.getList()
    },
    counselLogList(id) {
      this.counselLog.chooseOrgVisible = true
      this.counselLog.query.psy_settlement_id = id;
      this.counselLog.listLoading1 = true;
      showCounselLogList(this.counselLog.query).then((response) => {
        this.counselLog.result.data = response.data.list;
        this.counselLog.result.total = response.data.total;
        this.counselLog.listLoading1 = false;
      });
    },

    // 弹窗关闭
    settlementFormOnClose() {
      this.settlement.chooseOrgVisible = false;
      this.settlement.query.service_log_id = 0;
      this.getList()
    },
    counselLogInfo(service_log_id){
      this.settlement.chooseOrgVisible = true
      this.settlement.query.service_log_id = service_log_id;
      showCounselLogInfo(this.settlement.query).then((response) => {
        this.settlement.result.data = response.data;
        console.log(this.settlement.result.data)
      });
    },

    // 弹窗关闭
    approveListFormOnClose() {
      this.approveList.result = {
        data: [],
      };
      this.approveList.chooseOrgVisible = false;
      this.getList()
    },
    getApproveList(id){
      this.approveList.query.id = id;
      this.approveList.listLoading1 = true;
      getVerifyRecord(this.approveList.query).then((response) => {
        this.approveList.result.data = response.data;
        this.approveList.listLoading1 = false;
      });
    },

    //审核
    isApprove(id, review_status_value) {
      this.approve.query.id = id;
      this.approve.query.reason = '';
      this.approve.query.action = 1;
      this.approve.query.review_status_value = review_status_value;
    },

    addApprove() {
      var action_value =  this.approve.query.action;
      if (action_value == 1) {
        this.approve.query.action = 'agree'
      } else {
        this.approve.query.action = 'refuse'
      }
      console.log(this.approve.query)
      this.$confirm("确定要提交审核结果?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        verify(this.approve.query).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
            this.approveFormOnClose();
          } else {
            this.approveFormOnClose();
          }
        });
      }).catch(() => {
      });
    },

    // 弹窗关闭
    approveFormOnClose() {
      this.approve.chooseOrgVisible = false;
      this.approve.query.action = 1;
      this.approve.query.reason = '';
      this.approve.query.id = 0;
      this.approve.query.review_status_value = 0;
      this.getList()
    },

  },
  mounted() {

  },
};
</script>